import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { VEHICLE_TYPES } from 'constants'

import styles from './VehicleType.scss'

const VehicleType = (props) => {
    const className = classNames(styles.base, styles[`base__${props.type}`], {
        [styles.base__premium]: props.premium,
        [styles.base__mini]: props.mini,
    })
    return <span className={className} />
}

VehicleType.propTypes = {
    type: PropTypes.oneOf(VEHICLE_TYPES).isRequired,
    premium: PropTypes.bool,
    mini: PropTypes.bool,
}

export default VehicleType



// WEBPACK FOOTER //
// ./components/VehicleType/VehicleType.jsx